











































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import DataDokterByPoli from "@/services/DataUtility";
import { appModule } from "@/store/modules/app";
import RegisterKunjungan from "@/services/RegisterKunjungan";

@Component({
  inject: { isReadOnly: { default: () => () => false } }
})
export default class CardModalGantiDokter extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() readonly title!: string;
  @Prop() dtDokter!: object;
  @Prop() listDokterUnit: Array<object>;
  @Prop() poli!: object;
  @Prop() dtReg!: object;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  alert: string;
  success: string;
  allDokter = { c_doc_id: "0", id: "0", nama: "Semua" };
  get show() {
    return this.value;
  }
  set show(value) {
    this.$emit("input", value);
  }

  get listDokter() {
    return this.listDokterUnit.filter(item => item["id"] != 0);
  }

  simpanDokter() {
    if (this.readOnly) return;
    // console.log(this.dtDokter);
    appModule.setLoading(true);

    RegisterKunjungan.changeDokter(
      this.dtReg["register"],
      this.poli["unit_id"],
      this.dtDokter["c_doc_id"],
      this.dtReg["tgl"]
    )
      .then(dt => {
        if (dt.status == 1) {
          this.$emit("newValDokter", dt.data);
          this.success = "Data Berhasil disimpan";
        }

        this.show = false;
      })
      .finally(() => {
        appModule.setLoading(false);
      });
  }
}
